import script from "./PotentialCustomers.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialCustomers.vue?vue&type=script&setup=true&lang=js"

import "./PotentialCustomers.vue?vue&type=style&index=0&id=0b88601b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b88601b"]])

export default __exports__